<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="less">
body {
  font: 16px/1.5 "Helvetica Neue", Helvetica, Arial, "Microsoft Yahei",
    "Hiragino Sans GB", "Heiti SC", "WenQuanYi Micro Hei", sans-serif;
  color: #333;
}
html,
body,
h1,
h2,
h3,
h4,
h5,
h6,
p,
ul,
ol,
li,
dl,
dt,
dd,
input {
  margin: 0;
  padding: 0;
}
body{
  overflow-x: hidden;
}
/* 去除列表默认样式 */
ul,
ol {
  list-style: none;
}
a {
  text-decoration: none; /* 去掉下划线 */
  color: inherit; /* 继承父元素颜色，状态不变 */
}
/* 左右浮动 */
.fl {
  float: left;
}
.fr {
  float: right;
}

</style>

